import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 9069B66B-C7CA-478D-BE02-BC9863E27FDB
 * name align-vertical-top
 * version: 4.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/align-vertical-top.svg
 * tags
 */
export const AlignVerticalTopIcon = createSvgIcon(<><path d="M22 2V4H2V2H22M7 22H10V6H7V22M14 16H17V6H14V16Z" /></>, 'AlignVerticalTopIcon');
export default AlignVerticalTopIcon